import { render, staticRenderFns } from "./ProyectosEditar.vue?vue&type=template&id=96f372a6&scoped=true"
import script from "./ProyectosEditar.vue?vue&type=script&lang=js"
export * from "./ProyectosEditar.vue?vue&type=script&lang=js"
import style0 from "./ProyectosEditar.vue?vue&type=style&index=0&id=96f372a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f372a6",
  null
  
)

export default component.exports